var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import MarpBase from './MarpBase';
import bridge from './utils/bridge';
import { listen, send } from './utils/worker';
let memoizedCDNWorker;
const CDNWorker = () => {
    if (!memoizedCDNWorker) {
        const script = "self.importScripts('https://cdn.jsdelivr.net/npm/@marp-team/marp-vue/dist/worker.js')";
        const blob = new Blob([script], { type: 'text/javascript' });
        memoizedCDNWorker = new Worker(URL.createObjectURL(blob), {});
    }
    return memoizedCDNWorker;
};
let MarpWorker = class MarpWorker extends MarpBase {
    data() {
        return {
            $_marpWorker_rendered: undefined,
            $_marpWorker_queue: false,
        };
    }
    mounted() {
        this.$_marpWorker_destructor = listen(this.worker, {
            rendered: rendered => {
                this.$data.$_marpWorker_rendered = Object.freeze({
                    css: rendered.css,
                    slides: rendered.slides.map((h, i) => ({
                        slide: h,
                        comments: rendered.comments[i],
                    })),
                });
                const { $_marp_container: c, $_marpWorker_queue: q } = this.$data;
                if (q !== false && q !== true) {
                    send(this.worker, c.class, 'render', q[0], q[1]);
                    this.$data.$_marpWorker_queue = true;
                }
                else {
                    this.$data.$_marpWorker_queue = false;
                }
            },
        }, this.$data.$_marp_container.class);
        this.$_updateMarkdown();
    }
    destroyed() {
        if (this.$_marpWorker_destructor)
            this.$_marpWorker_destructor();
    }
    render(createElement) {
        const h = bridge(createElement);
        const defaultRenderer = slides => slides
            ? slides.map(({ slide }) => h("marp-slide", { slide: slide }))
            : undefined;
        const { $_marpWorker_rendered: rendered } = this.$data;
        return (h("div", null,
            rendered && h('style', {}, rendered.css, this.$_marp_style),
            ((!rendered && this.$scopedSlots.initial) ||
                this.$scopedSlots.default ||
                defaultRenderer)((rendered || {}).slides)));
    }
    $_updateMarkdown() {
        if (this.$data.$_marpWorker_queue) {
            this.$data.$_marpWorker_queue = [this.markdown || '', this.$_marp_options];
        }
        else {
            this.$data.$_marpWorker_queue = true;
            send(this.worker, this.$data.$_marp_container.class, 'render', this.markdown || '', this.$_marp_options);
        }
    }
};
__decorate([
    Prop({
        default: CDNWorker,
        validator: obj => {
            const { Worker } = window;
            return obj && (Worker ? obj instanceof Worker : true);
        },
    })
], MarpWorker.prototype, "worker", void 0);
MarpWorker = __decorate([
    Component({
        watch: {
            markdown() {
                this.$_updateMarkdown();
            },
            options() {
                this.$_updateMarkdown();
            },
        },
    })
], MarpWorker);
export { MarpWorker };
export default MarpWorker;
